function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycleBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 5.49945L19.75 11.4995M5.25 5.49945L5.855 15.5365C6.009 18.1065 6.087 19.3915 6.729 20.3165C7.046 20.7731 7.45469 21.1586 7.929 21.4485C8.511 21.8045 9.213 21.9445 10.25 21.9995M11.75 15.4995L12.886 16.9655C13.0923 16.1952 13.5242 15.5042 14.1261 14.9812C14.728 14.4582 15.4725 14.127 16.264 14.0301C17.0555 13.9333 17.8579 14.0752 18.5681 14.4377C19.2783 14.8002 19.864 15.3667 20.25 16.0645M21.75 20.4995L20.614 19.0354C20.4093 19.7997 19.9826 20.4861 19.3878 21.0078C18.793 21.5295 18.0568 21.8631 17.2724 21.9664C16.488 22.0697 15.6906 21.938 14.981 21.5881C14.2714 21.2381 13.6816 20.6856 13.286 20.0005M3.75 5.49945H21.75M16.806 5.49945L16.123 4.09145C15.67 3.15545 15.443 2.68845 15.052 2.39645C14.9651 2.33177 14.8732 2.27424 14.777 2.22445C14.344 1.99945 13.824 1.99945 12.785 1.99945C11.719 1.99945 11.186 1.99945 10.745 2.23345C10.6475 2.28566 10.5545 2.34587 10.467 2.41345C10.072 2.71645 9.851 3.20145 9.409 4.17045L8.803 5.49945",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleBin);
export default __webpack_public_path__ + "static/media/recycleBin.558f2a362c1e41a1e4069ce0e93a1694.svg";
export { ForwardRef as ReactComponent };